export default __webpack_public_path__ + "static/media/VengarreConsulting.afdfdffb.png";